import React from 'react'
import AppNavigator from './AppNavigator'
import { CssBaseline } from '@mui/material';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource-variable/readex-pro';
import '../config/firebase.config'


const AppWrapper = (props) => {
  if (
    window.location.host === "personal-architect-garages.web.app" ||
    window.location.host === "personal-architect-garages.firebaseapp.com"
  ) {
    window.location.href = "https://garages.personalarch.com"
  }
  return (
    <>
      <AppNavigator />
      <CssBaseline />
    </>
  )
}

export default AppWrapper